var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.keepAlive)?_c('div',[_c('nav-bar'),_c('router-view'),_c('tab-bar')],1):_vm._e(),(!_vm.$route.meta.keepAlive)?_c('div',[_c('div',[_c('router-view')],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }